import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { ADMIN_MENU } from "@/data/adminMenu";
import { getAdminSession, puedeAccederModulo } from "@/data/adminAuthStore";

/**
 * Sidebar del portal administrativo. Los ítems con `key` mapeada a un módulo
 * se ocultan si el rol de la sesión no tiene permiso (p. ej. MARKETING no ve
 * "Plantillas de mesas"). El backend conserva la autoridad final.
 */
export default function AdminSidebar({ onNavigate, testIdSuffix = "" }) {
  const rol = getAdminSession()?.rol || null;
  const visibles = ADMIN_MENU.filter(
    (m) => !m.key || puedeAccederModulo(rol, m.key),
  );
  return (
    <nav
      aria-label="Navegación administrativa"
      className="flex-1 py-4 px-3 overflow-y-auto"
    >
      <ul className="flex flex-col gap-1">
        {visibles.map(
          ({ to, end, label, icon: Icon, testId, disabled, disabledLabel }) => (
            <li key={to}>
              {disabled ? (
                <div
                  data-testid={`${testId}${testIdSuffix}`}
                  aria-disabled="true"
                  title={disabledLabel || "Próximamente"}
                  className={cn(
                    "flex items-center gap-3 rounded-xl px-4 py-3 text-sm",
                    "text-muted-foreground/70 cursor-not-allowed select-none",
                  )}
                >
                  <Icon className="w-[18px] h-[18px]" strokeWidth={1.6} />
                  <span className="flex-1">{label}</span>
                  <span className="text-[10px] uppercase tracking-widest text-muted-foreground/70 border hairline rounded-full px-2 py-0.5">
                    {disabledLabel || "Próximamente"}
                  </span>
                </div>
              ) : (
                <NavLink
                  to={to}
                  end={end}
                  data-testid={`${testId}${testIdSuffix}`}
                  onClick={onNavigate}
                  className={({ isActive }) =>
                    cn(
                      "group relative flex items-center gap-3 rounded-xl",
                      "px-4 py-3 text-sm transition-all duration-200",
                      isActive
                        ? "bg-primary/5 dark:bg-accent/10 text-primary dark:text-accent font-medium"
                        : "text-muted-foreground hover:bg-muted/60 hover:text-foreground",
                    )
                  }
                >
                  {({ isActive }) => (
                    <>
                      <Icon
                        className="w-[18px] h-[18px]"
                        strokeWidth={isActive ? 2 : 1.6}
                      />
                      <span>{label}</span>
                      {isActive && (
                        <span className="absolute right-3 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-accent" />
                      )}
                    </>
                  )}
                </NavLink>
              )}
            </li>
          ),
        )}
      </ul>
    </nav>
  );
}
